'use client';
import Script from 'next/script';

/* ── CPL v5 §4 P4 — 네이버 전환추적 «공통 스크립트» (2026-09-23) ───────────────
 *
 * 네이버 전환추적은 «두 조각» 이다. 하나만 깔면 전환은 계속 0 이다.
 *   ① 공통 스크립트 — 모든 페이지. 광고 클릭이 남긴 `NaPm` 파라미터를 읽어 쿠키에 «귀속» 을
 *      저장한다(wcs.inflow). 이게 없으면 나중에 전환을 쏴도 어느 «검색어» 인지 못 붙는다.
 *   ② 전환 스크립트 — 접수 성공 시점. lib/naver-conversion.ts 가 담당한다.
 * 여기는 ①이다.
 *
 * ⚠️ 그래서 이 컴포넌트는 리드폼이 있는 페이지가 아니라 «루트 레이아웃» 에 붙는다.
 *    광고 착지 페이지와 폼 제출 페이지가 다를 수 있고(허브 → 상세), 귀속은 «착지» 에서 잡힌다.
 * ⚠️ NaPm 은 middleware 의 `/apt?region=` 301 에서도 «들고 간다»(TRACKING_PARAM_RE,
 *    src/lib/seo/facet.ts:101). 리다이렉트가 귀속을 끊지 않는다는 것을 확인하고 얹었다.
 *
 * ⛔ env 가 없으면 «아무것도 로드하지 않는다». GA 와 같은 규율이다(layout.tsx:234) —
 *    미리보기·로컬에서 남의 전환추적 계정으로 허위 전환을 쏘지 않기 위해서다.
 * ⚠️ SPA 라우트 이동마다 PV 를 다시 쏘지 않는다. 전환 귀속은 «착지 1회» 로 충분하고
 *    (쿠키에 저장된다), 라우트마다 쏘면 프리미엄 로그분석 쪽 PV 만 부풀린다.
 *    ⛔ PV 가 더 필요하면 그건 별도 판정이다 — 여기서 겸사겸사 넣지 말 것.
 */

type WcsWindow = Window & {
  wcs?: { inflow?: (domain: string) => void };
  wcs_add?: Record<string, string>;
  wcs_do?: (arg?: unknown) => void;
};

export default function NaverWcs() {
  const wa = process.env.NEXT_PUBLIC_NAVER_WA;
  if (!wa) return null;

  return (
    <Script
      src="https://wcs.naver.net/wcslog.js"
      strategy="afterInteractive"
      onLoad={() => {
        try {
          const w = window as WcsWindow;
          if (!w.wcs) return;
          // wcslog 가 로드 시점에 wcs_add 를 만들어 두지만, 없을 수도 있다고 보고 감싼다.
          if (!w.wcs_add) w.wcs_add = {};
          w.wcs_add['wa'] = wa;
          // 1차 도메인만 넘긴다 — 프로토콜·www 제외가 공식 규격이다.
          w.wcs.inflow?.(window.location.hostname.replace(/^www\./, ''));
          w.wcs_do?.();
        } catch {
          /* 계측은 서비스를 막지 않는다 */
        }
      }}
      onError={() => {}}
    />
  );
}
